import { Loading } from "@/components/ui/loading";
import { useAuth } from "@/features/auth/context/AuthContext";
import { UserRole } from "@/lib/auth-utils";
import React from "react";
import { Navigate } from "react-router-dom";

interface RoleGuardProps {
  children: React.ReactNode;
  allowedRoles?: UserRole[];
  redirectTo?: string;
}

export function RoleGuard({
  children,
  allowedRoles = [],
  redirectTo = "/applications"
}: RoleGuardProps) {
  const { loading, profile, originalProfile } = useAuth();

  // Wait for authentication to complete before checking roles
  if (loading) {
    return <Loading text="Berechtigung prüfen..." />;
  }
  if (
    !profile ||
    (!allowedRoles.includes(profile.role) &&
      !profile.isSuperUser &&
      !originalProfile?.isSuperUser)
  ) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}
